<style scoped>
.loginbg1 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.loginbg2 {
  width: 800px;

  display: flex;
  align-items: center;
  flex-direction: column;
}
.loginbg2_1 {
  width: 800px;
  height: 1000px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.loginbg3 {
  display: flex;
  align-items: center;
  width: 720px;
  margin-left: 40px;
}
.loginbg4 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.loginbg5 {
  min-width: 100px;
}
</style>
<template>
  <div class="loginbg1">
    <div class="loginbg2" v-bgImg="pic_3" style="overflow: scroll">
      <div class="loginbg2">
        <div style="font-size: 25px;margin-top: 30px;width:778px;height:76px" v-bgImg="pic_2"></div>
        <div style="font-size: 25px;margin-top: 20px;width:90%">请您如实填写如下个人信息：</div>
        <div class="loginbg3">
          <div class="loginbg5" style="font-size: 25px;">联系人:</div>
          <div class="border-bottom-color-light">
            <input
              v-model="info.talent_contact"
              style="mix-height:60px;width: 180px;  color: red;background-color:   transparent ; outline:none;line-height:60px;border: none;font-size: 25px"
            >
          </div>
          <div class="loginbg5" style="font-size: 25px">身份证号:</div>
          <div class="border-bottom-color-light">
            <input
              v-model="info.talent_idcard"
              style="height:60px;  color: red;width: 290px; background-color:   transparent ; outline:none;line-height:60px;border: none;font-size: 25px"
            >
          </div>
        </div>
        <div class="loginbg3">
          <div class="loginbg5" style="font-size: 25px">电话:</div>
          <div class="border-bottom-color-light">
            <input
              v-model="info.talent_phone"
              style="height:60px;  color: red;width: 180px; background-color:   transparent ; outline:none;line-height:60px;border: none;font-size: 25px"
            >
          </div>
          <div class="loginbg5" style="font-size: 25px">电子邮箱:</div>
          <div class="border-bottom-color-light">
            <input
              v-model="info.talent_email"
              style="height:60px;  color: red;width: 290px; background-color:   transparent ; outline:none;line-height:60px;border: none;font-size: 25px"
            >
          </div>
        </div>
        <div class="loginbg3">
          <div class="loginbg5" style="font-size: 25px">地址:</div>
          <div class="border-bottom-color-light">
            <input
              v-model="info.talent_address"
              style="height:60px;  color: red;width:  600px; background-color:   transparent ; outline:none;line-height:60px;border: none;font-size: 25px"
            >
          </div>
        </div>
        <div class="loginbg3">
          <div class="loginbg5" style="font-size: 25px">常活跃平台:</div>
          <div class="border-bottom-color-light">
            <input
              v-model="info.talent_platforms"
              style="height:60px;  color: red;width: 550px; background-color:   transparent ; outline:none;line-height:60px;border: none;font-size: 25px"
            >
          </div>
        </div>
        <div class="loginbg3">
          <div class="loginbg5" style="font-size: 25px">平台ID:</div>
          <div class="border-bottom-color-light">
            <input
              v-model="info.talent_platform_ids"
              style="height:60px;  color: red;width: 600px;background-color:   transparent ;  outline:none;line-height:60px;border: none;font-size: 25px"
            >
          </div>
        </div>
        <div class="loginbg3">
          <div class="loginbg5" style="font-size: 25px">昵称:</div>
          <div class="border-bottom-color-light">
            <input
              v-model="info.talent_nick"
              style="height:60px;  color: red;width: 600px;  background-color:   transparent ;outline:none;line-height:60px;border: none;font-size: 25px"
            >
          </div>
        </div>
        <div class="loginbg5" style="font-size: 25px;width:86%">请您提供个人主页链接</div>
        <div class="loginbg4">
          <div v-for="(list,index) in lists" :key="index">
            <div class="border-color-light">
              <el-input
                style="width: 700px;resize:none; background:transparent;margin-top:30px;"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                :Color="'red'"
                placeholder="请输入内容"
                v-model="info.talent_website"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="loginbg5" style="font-size: 25px;width:86%">您专注如下哪种类别：</div>
        <div class="loginbg3">
          <label
            style="height:60px;width: 33%; outline:none;line-height:60px;border: none;font-size: 25px"
            value="man"
          >
            <input type="radio" v-model="info.talent_focus" value="烘焙">烘焙类
          </label>
          <label
            style="height:60px;width: 33%; outline:none;line-height:60px;border: none;font-size: 25px"
            value="man"
          >
            <input type="radio" v-model="info.talent_focus" value="家常">家常类
          </label>
          <label
            style="height:60px;width: 33%; outline:none;line-height:60px;border: none;font-size: 25px"
            value="man"
          >
            <input type="radio" v-model="info.talent_focus" value="面点">面点类
          </label>
        </div>
        <div class="loginbg5" style="font-size: 25px;width:86%">您是否有自己的粉丝群？</div>
        <div class="loginbg3">
          <label
            style="height:60px;width: 33%; outline:none;line-height:60px;border: none;font-size: 25px"
            value="man"
          >
            <input type="radio" v-model="info.talent_is_has_fans" value="true">是
          </label>
          <label
            style="height:60px;width: 33%;  outline:none;line-height:60px;border: none;font-size: 25px"
            value="man"
          >
            <input type="radio" v-model="info.talent_is_has_fans" value="false">否
          </label>
        </div>
        <div class="loginbg3" style="display:flex;justify-content:center;align-items: center;">
          <el-button
            @click="up"
            size="mini"
            type="primary"
            style="height:60px;width: 160px;margin-top: 50px;color:rgb(255, 255, 255);font-size:22px; text-align:center;"
          >上一步</el-button>
          <el-button
            @click="getinfo"
            size="mini"
            type="primary"
            style="margin-left: 160px;height:60px;width: 160px;margin-top: 50px;color:rgb(255, 255, 255);font-size:22px; text-align:center;"
          >提交</el-button>
        </div>
        <div style="height:31px;width: 466px;margin-top:50px" v-bgImg="pic_1"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'information',
  components: {},
  props: ['info'],
  data() {
    return {
      pic_1: this.utils.getQiniuWidthUrl('FmZjksM2ssWryaLlXd7E3hbpzkbQ^尾标.png^7272.png', 466, 2, 'png'),
      pic_2: this.utils.getQiniuWidthUrl('FicyKI2f_9Yo2L8C-5l7qsbTm7VJ^合同头标.png^10610.png', 778, 2, 'png'),
      pic_3: this.utils.getQiniuWidthUrl('Filt7-f1xAhUPHj-lBW-ZBMJ_hKH^合同背景.png^761526.png', 800, 2, 'png'),
      pic_4: this.utils.getQiniuWidthUrl('FiNyoE0HIftPfqDXsWtIBNQvEi6H^水印.png^48231.png', 800, 2, 'png'),
      lists: [{
        link: "",
        num: ""
      }],
    }
  },
  mounted() {

  },
  methods: {
    getinfo() {
      this.$emit('getinfo', 'determine', this.lists)
    },
    up() {
      this.$emit('up', 'types')
    },
    EnterFun() {
      if (this.lists.length < 4) {
        let cope = {
          link: "",
          num: ""
        }
        this.lists.push(cope);
        console.log(this.lists)

      }

    }
  }
}
</script>